import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

export interface GisBoqGenerateDialogData {
  project_id: number;
  route_id?: number;
  from_km?: number;
  to_km?: number;
  domain?: string;
  target?: 'standard' | 'road';
  boq_code?: string;
  boq_name?: string;
  administrative_authority?: string;
  road_type?: string;
}

@Component({
  selector: 'app-gis-boq-generate-dialog',
  templateUrl: './gis-boq-generate-dialog.component.html',
  styleUrls: ['./gis-boq-generate-dialog.component.css'],
})
export class GisBoqGenerateDialogComponent implements OnInit {
  form!: FormGroup;
  preview: any = null;
  previewing = false;
  applying = false;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private toastr: ToastrMsgService,
    private router: Router,
    public dialogRef: MatDialogRef<GisBoqGenerateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GisBoqGenerateDialogData
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      boq_code: [this.data.boq_code || '', Validators.required],
      boq_name: [this.data.boq_name || '', Validators.required],
      target: [this.data.target || 'standard', Validators.required],
      administrative_authority: [this.data.administrative_authority || 'NHAI'],
      road_type: [this.data.road_type || 'National Highway'],
    });
    this.runPreview();
  }

  get payload(): any {
    return {
      project_id: this.data.project_id,
      route_id: this.data.route_id,
      from_km: this.data.from_km,
      to_km: this.data.to_km,
      domain: this.data.domain || 'road',
      target: this.form.value.target,
    };
  }

  runPreview(): void {
    this.previewing = true;
    this.preview = null;
    this.api.previewGisBoq(this.payload).subscribe({
      next: (res: any) => {
        this.preview = res?.data;
        this.previewing = false;
      },
      error: (err) => {
        this.previewing = false;
        this.toastr.error(err?.error?.error || 'Preview failed');
      },
    });
  }

  apply(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.applying = true;
    const body = {
      ...this.payload,
      ...this.form.value,
    };
    this.api.applyGisBoq(body).subscribe({
      next: (res: any) => {
        this.applying = false;
        this.toastr.success(res?.data?.rfq?.id ? 'BOQ created from GIS. Draft RFQ is ready — send for bidding to invite vendors.' : 'BOQ created from GIS geometry');
        this.dialogRef.close(res?.data);
        const d = res?.data;
        if (d?.boq_id) {
          void this.router.navigate(['/home/boq', d.boq_id, 'edit']);
        } else if (d?.road_boq_id) {
          void this.router.navigate(['/home/road-boq', d.road_boq_id, 'edit']);
        }
      },
      error: (err) => {
        this.applying = false;
        this.toastr.error(err?.error?.error || 'Failed to create BOQ');
      },
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount || 0);
  }
}
